import React from "react";

import Header from "../../components/Header/Header";
import Hero from "./Hero/Hero";
import Modal from "./Modal/Modal";

const MainPage: React.FC = () => {
  return (
    <div className="main-body bg-cream md:pb-10">
      <Header />
      <Hero />
      <Modal />
    </div>
  );
};

export default MainPage;
